module.exports = __webpack_public_path__ + "static/img/20.b021134.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/20.png
// module id = Gvp2
// module chunks = 6